import { ComponentProps } from "@declarations/props";
import { linkPage } from "@utils/router";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  BiSolidEdit,
  BiSolidUser,
  BiSolidHome,
  BiTransferAlt,
  BiDetail,
  BiCalendar,
  BiListCheck,
} from "react-icons/bi";
import "@assets/css/custom/bottom-nav.css";

export const BottomNavigation: ComponentProps<{
  type: "home";
}> = ({ type = "home" }) => {
  const location = useLocation();
  const navigate = useNavigate();

  switch (type) {
    case "home":
      return (
        <nav className="navbar navbar-expand bg-gradient">
          <ul className="navbar-nav nav-justified tw-w-full">
            <li className="nav-item">
              <div
                onClick={() => navigate(linkPage.HOME_DASHBOARD)}
                // to={linkPage.HOME_DASHBOARD}
                // replace={true}
                className={`btn-link nav-link tab ${
                  location.pathname === linkPage.HOME_DASHBOARD ? "active" : ""
                }`}
              >
                <BiSolidHome size={21} />
                <span className="tw-text-[0.6rem] tw-font-bold nav-name">
                  Beranda
                </span>
              </div>

              <div
                onClick={() =>
                  navigate(
                    linkPage.FINANCE_REQUEST_VA.replace(":type", "zis"),
                    {
                      state: {
                        tagihan: false,
                        tipe: "zis",
                      },
                    }
                  )
                }
                className={`btn-link nav-link tab ${
                  location.pathname ===
                  linkPage.FINANCE_REQUEST_VA.replace(":type", "zis")
                    ? "active"
                    : ""
                }`}
              >
                <BiTransferAlt size={21} />
                <span className="tw-text-[0.6rem] tw-font-bold nav-name">
                  ZIS
                </span>
              </div>

              <div
                onClick={() => navigate("/finance/data-va")}
                className={`btn-link nav-link tab ${
                  location.pathname === "/finance/data-va" ? "active" : ""
                }`}
              >
                <BiDetail size={21} />
                <span className="tw-text-[0.6rem] tw-font-bold nav-name">
                  Laporan VA
                </span>
              </div>

              <div
                onClick={() => navigate(linkPage.HOME_PROFILE)}
                className={`btn-link nav-link tab ${
                  location.pathname === linkPage.HOME_PROFILE ? "active" : ""
                }`}
              >
                <BiSolidUser size={21} />
                <span className="tw-text-[0.6rem] tw-font-bold nav-name">
                  Profil
                </span>
              </div>
            </li>
          </ul>
        </nav>
      );
  }
};
